import { gql } from "graphql-tag";

import { documentLink, externalLink } from "~/app/prismic/prismic-fragments";

export const getMemberBenefits = pageType => gql`
  fragment ${pageType}_Member_benefits on ${pageType}BodyMember_benefits {
    type
    primary {
      title
      background_color
      text_color
    }
    fields {
      image
      title
      description
      link{
        ... documentLink
        ... externalLink
      }
    }
}
${documentLink}
${externalLink}`;
